export default __webpack_public_path__ + "static/media/9.f43c57f7.jpeg";